/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NavIconProspector from './nav-icon-prospector.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NavIconProspector {...validProps} />;
}
SvgComponent.iconName = 'navIconProspector';

export const NavIconProspectorIcon = svgIconWrapper(SvgComponent);
